import classnames from 'classnames'
import { addStepNumbersToTitles } from 'helpers/Printout'
import { isChallenge } from 'helpers/Step'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { translate } from 'react-i18next'

import './Content.scss'

export class Content extends Component {
  constructor(props) {
    super(props)
    this.stepNumber = 0
  }

  componentDidMount() {
    addStepNumbersToTitles(this.props.t, this.props.theme)
  }

  challengeLabel(step) {
    return isChallenge(step) ? (
      <span className="c-print-content__challenge-label">
        {this.props.t('project.steps.challenge')}
      </span>
    ) : null
  }

  contentClassNames(step, baseClass) {
    let classnamesArray = [baseClass]

    if (isChallenge(step)) {
      classnamesArray.push(`${baseClass}--challenge`)
    } else {
      classnamesArray.push(`${baseClass}--with-formatted-title`)
    }

    return classnames(classnamesArray)
  }

  incrementStepNumber = (step) => {
    if (!isChallenge(step)) {
      this.stepNumber += 1
    }
  }

  render() {
    return (
      <div className="c-print-content">
        {this.props.steps.map((step, key) => {
          this.incrementStepNumber(step)

          return (
            <div
              className={this.contentClassNames(step, 'c-print-content__step')}
              data-step-number={this.stepNumber}
              key={key}
            >
              {this.challengeLabel(step)}
              <div
                className={this.contentClassNames(
                  step,
                  'c-print-content__step-content'
                )}
                dangerouslySetInnerHTML={{ __html: step.content }}
              />
            </div>
          )
        })}
      </div>
    )
  }
}

Content.propTypes = {
  steps: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
}

export default translate('translations')(Content)
